<section *ngFor="let product of products$ | async; let $index = index">
  <bca-product
    [company]="company$ | async"
    [product]="product"
    [totalProductCount]="totalProductCount$ | async"
    [productNumber]="$index + 1"
    (delete)="onProductDelete($event)"
    (deleteAddon)="onAddonDelete($event, product.id)"
    (edit)="onProductEdit($event)"
    (editUser)="onUserEdit($event)"
  >
  </bca-product>
</section>
<section class="mt-3">
  <div>
    {{ 'VERIFY.SUBTOTAL' | translate }}:
    <span class="float-right"> € {{ subTotalReceiptPrice$ | async | priceFormat }} </span>
  </div>
  <div class="nes-mb-1">
    {{ 'VERIFY.TAX_PRICE' | translate }}:
    <span class="float-right">€ {{ tax$ | async | priceFormat }}</span>
  </div>
  <div class="mb-2">
    <hr class="articleSeparator priceSummaryLine" />
    <h2 class="headingM gridHeader__heading priceSeparation">
      <div >
      {{ 'FREQUENTION.MONTH_TOTAL' | translate }}
      </div>
      <div class="float-right"> € {{ totalReceiptPrice$ | async | priceFormat }} </div>
    </h2>
  </div>

</section>
